import React, { memo } from 'react'
import { RelativeDateTime } from 'transfix-ui/components/RelativeDateTime'
import { IStop } from 'apps/fleet-planner/types'
import {
  IActivity,
  isActivityCheckInTimeUpdated,
  isActivityCheckOutTimeUpdated,
  isActivityShared,
  isActivityStatusUpdated,
} from 'apps/fleet-planner/types/activity'
import { ActivityIcon } from './ActivityIcon'
import { ActivitySubtext } from './ActivitySubtext'
import { ActivitySubtextDriver } from './ActivitySubtextDriver'
import { ActivitySubtextSubscriber } from './ActivitySubtextSubcriber'
import { ActivityText } from './ActivityText'

interface IActivityRowProps {
  activity: IActivity
  loadStops?: IStop[]
  isExternal?: boolean
}

export const ActivityRow = memo<IActivityRowProps>(({ activity, loadStops = [], isExternal }) => {
  const { createdAt } = activity || {}
  const hasSubtext =
    (isActivityCheckOutTimeUpdated(activity) ||
      isActivityStatusUpdated(activity) ||
      isActivityCheckInTimeUpdated(activity)) &&
    activity.metadata.stop

  return (
    <div className={`load-details-activity-row ${hasSubtext ? '' : 'items-center'}`}>
      <div className='flex-shrink mt1 mt0-m'>
        <ActivityIcon activity={activity} />
      </div>
      <div className='flex-auto pl3'>
        <ActivityText activity={activity} loadStops={loadStops} isExternal={isExternal} />
        <span className='load-details-activity-timestamp'>
          <RelativeDateTime datetime={createdAt} isShorthand />
        </span>
        {hasSubtext && (
          <ActivitySubtext
            activity={activity}
            loadStops={loadStops}
            className='load-details-activity-text-item'
            iconSize='large'
          />
        )}
        {isActivityStatusUpdated(activity) && <ActivitySubtextSubscriber activity={activity} />}
        {isActivityShared(activity) && <ActivitySubtextDriver activity={activity} />}
      </div>
    </div>
  )
})
